import * as React from 'react'
import { Table, TableHeader, TableRow } from 'features/Table'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import { useGetPhoneSystemServicesQuery } from 'src/generated/graphql'
import LoadingOverlay from 'components/Loading/LoadingOverlay'
import Button from 'components/Button'
import * as sLay from 'styles/modules/layout.scss'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import cn from 'classnames'

export interface IPhoneSystemListComponentProps {
  showPhoneSystemFormModal: Function
}

export const PhoneSystemListComponent = (props: IPhoneSystemListComponentProps) => {
  const { data, loading } = useGetPhoneSystemServicesQuery()

  if (loading) return <LoadingOverlay transparent />

  return (
    <div>
      <div className={cn(sMarg.mb30, sLay['layout-row'], sLay['layout-align-start-center'])}>
        <div className={cn(sLay.flex, sText.descrip3)}></div>
        <Button color="tertiary" size="sm" onClick={() => props.showPhoneSystemFormModal()} rect>
          Create Phone System
        </Button>
      </div>

      {data?.phoneSystems.length === 0 ? (
        <EmptyMessageCard
          title="You have no phone systems"
          subtitle="Give us a call to find out more"
        />
      ) : (
        <Table
          header={
            <TableHeader>
              <div>Name</div>
              <div style={{ maxWidth: '76px' }} />
            </TableHeader>
          }
        >
          {data?.phoneSystems.map(service => {
            return (
              <TableRow key={service.id}>
                <div>{service.name}</div>
                <div style={{ maxWidth: '76px' }}>
                  <Button
                    color="tertiary"
                    size="xs"
                    ghost
                    to={`/dashboard/hosted-voice/phone-systems/${service.id}`}
                  >
                    View
                  </Button>
                </div>
              </TableRow>
            )
          })}
        </Table>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemList/PhoneSystemList.tsx